import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { format, parseISO } from 'date-fns';
import * as am5percent from "@amcharts/amcharts5/percent";
import {
    GetPostMethodData,
    DecryptAESdata,
} from "../../../../provider/ServiceProvider";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import animation from '../../../../images/jm-animation.gif';


function PortfolioClassification(props) {
    const [data, setData] = useState([]);
    const { BaseURL } = useContext(URLstateContext);
    const [chartdata, setchartdata] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);
    let getSchemeCodeIn = props.getSchemeCode;

    useEffect(() => {
        setloadingshow(true);
        GetPostMethodData(BaseURL + "GetFundPortfolioRating", {
            IVSchemeCode: getSchemeCodeIn,
        }).then((data) => {
            setloadingshow(false);
            if (data.data != null && data.data.length > 0) {
                setData(DecryptAESdata(data.data));
                setchartdata(DecryptAESdata(data.data));
                setloadingshow(false);
                // console.log(DecryptAESdata(data.data))
            }
        });
    }, [BaseURL]);

    useLayoutEffect(() => {
        am5.addLicense("AM5C420959785");
        var root = am5.Root.new("PortfolioChartDiv");
        root.setThemes([
            am5themes_Animated.new(root)
        ]);

        var chart = root.container.children.push(am5percent.PieChart.new(root, {
            layout: root.verticalLayout,
        }));

        var series = chart.series.push(am5percent.PieSeries.new(root, {
            valueField: "value",
            categoryField: "category",
            legendLabelText: "{category}",

        }));

        series.get("colors").set("colors", [
            am5.color("#3bafcb"),
            am5.color("#25d8ff"),
            am5.color("#ace3df"),
            am5.color("#063b73"),
            am5.color("#869d9f"),
        ]);

        function generateChartData() {
            let chartData = [];
            for (var i = 0; i < chartdata.length; i++) {
                if (chartdata[i].PercentToAss != null) {
                    chartData.push({
                        category: chartdata[i].ProductName,
                        value: (chartdata[i].PercentToAss).toFixed(2)
                    });
                }
            }

            return chartData;
        }
        let data = generateChartData();

        series.data.setAll(data);

        // series.ticks.template.set("visible", true);
        // series.labels.template.set("forceHidden", true);

        series.labels.template.setAll({
            maxWidth: 100,
            oversizedBehavior: "wrap",
            fontSize: 11,
            text: "{value}%"
        });

        var legend = chart.children.push(am5.Legend.new(root, {
            dx: 80,
            clickTarget: 'none',
            centerX: am5.percent(75),
            x: am5.percent(50),
            layout: root.verticalLayout
            // layout: am5.GridLayout.new(root, {
            //     maxColumns: 2,
            //     fixedWidthGrid: true
            // })
        }));
        legend.valueLabels.template.set("forceHidden", true);
        legend.data.setAll(series.dataItems);

        series.appear(1000, 100);
        return () => {
            root.dispose();
        };
    }, [chartdata]);

    return (
        <>

            <div className="gradiant-head-box">
                <div className="gradiant-head-container">
                    <h3 className="gradiant-head">Portfolio Classification</h3>
                </div>
                <div className="gradiant-content">
                    <div className="padding-box-inner paddingChart">
                        {(data.length === 0) ? <h6 className="errorMsg" role="alert">No Data Found !!!</h6> : ''}
                        {loadingshow ? <div className="textcentervertex" role="status" aria-live="polite" aria-busy="true">
                            <img src={animation} alt="" aria-hidden="true"/>
                            <div className="model_popup">Please Wait...</div>
                        </div> : ""
                        }
                        <div id="PortfolioChartDiv" style={{ width: "100%", height: "300px" }}></div>
                    </div>
                </div>

            </div>

        </>
    )
}

export default PortfolioClassification